<template>
  <v-row justify="left">
    <v-dialog v-model="dialog" width="600px">
      <template v-slot:activator="{ on }">
        <v-btn style="margin-left: 15px;" small dark v-on="on" :color="'#CCCCCC'">{{ $t('agenda.showMoreInfo') }}</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{title}}</span>
        </v-card-title>
        <v-card-text><span v-html="description" /></v-card-text>
        <v-card-actions>
          <v-spacer />
            <v-btn dark :color="'#CCCCCC'" @click="dialog = false">{{$t('common.close')}}</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'AgendaDetail',
    props: {
      title: {
        type: String,
        required: false,
        default: ''
      },
      description: {
        type: String,
        required: false,
        default: ''
      },
    },
    data () {
      return {
        dialog: false,
      }
    },
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
  }
</script>
